import { render, staticRenderFns } from "./ConcernSubstanceListsStep.vue?vue&type=template&id=f8606242&"
import script from "./ConcernSubstanceListsStep.vue?vue&type=script&lang=js&"
export * from "./ConcernSubstanceListsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports